import { Store } from 'vuex';
import { Getters, Context } from 'vuex-smart-module';
import ClientsSharedState from './state';
import ClientsStore from '../../store';
import ClientsState from '../../store/state';

export default class ClientsSharedGetters extends Getters<ClientsSharedState> {
  clients_store!: Context<typeof ClientsStore>;

  $init(store: Store<ClientsState>): void {
    this.clients_store = ClientsStore.context(store);
  }

  get clients() {
    return this.clients_store.state.clients;
  }
}
